import React from 'react';
import { motion } from 'framer-motion';
import { Lock, CreditCard } from 'lucide-react';
import { Button } from './ui/Button';
export function PricingSection() {
  return <section id="pricing" className="py-20 md:py-32 bg-cream" data-id="element-140">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-[2.5rem] shadow-2xl overflow-hidden border border-sage-100" data-id="element-142">
          <div className="bg-sage-800 text-center py-4" data-id="element-143">
            <p className="text-sage-100 font-medium tracking-widest text-sm uppercase" data-id="element-144">
              Oferta especial por tiempo limitado
            </p>
          </div>

          <div className="p-8 md:p-16 text-center" data-id="element-145">
            <h2 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-146">
              Comienza tu Reset Hoy
            </h2>
            <p className="text-charcoal-light mb-10" data-id="element-147">
              Acceso inmediato de por vida a los 15 módulos + 3 bonos
              exclusivos.
            </p>

            <div className="flex flex-col items-center justify-center mb-10" data-id="element-148">
              <p className="text-xl text-gray-400 line-through mb-2 font-medium" data-id="element-149">
                Precio Real: $67.00 USD
              </p>
              <div className="flex items-start justify-center text-sage-700" data-id="element-150">
                <span className="text-3xl font-bold mt-2" data-id="element-151">$</span>
                <span className="text-7xl md:text-8xl font-bold tracking-tighter" data-id="element-152">
                  14
                </span>
                <span className="text-xl font-bold mt-2 ml-1" data-id="element-153">USD</span>
              </div>
            </div>

            <Button href="https://noveliahub.com/cart/44193210630180:1" className="w-full md:w-auto md:px-16 py-5 text-lg md:text-xl shadow-xl shadow-sage-700/20 mb-6" data-id="element-154">
              SÍ, QUIERO VOLVER A SENTIRME TÚ
            </Button>

            <div className="flex flex-col items-center justify-center gap-3 text-sm text-charcoal-light/70" data-id="element-155">
              <div className="flex items-center gap-2" data-id="element-156">
                <Lock size={16} data-id="element-157" />
                <span data-id="element-158">Pago 100% seguro y encriptado.</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-159">
                <CreditCard size={16} data-id="element-160" />
                <span data-id="element-161">Recibirás acceso inmediato en tu email.</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}